import { UniversalMessageType } from "../types/universalChatTypes";

export function mapResourceTypeToLabel(
  resourceType: string | undefined,
): string {
  if (!resourceType) return "";
  switch (resourceType) {
    case "CarePlan":
      return "Care Plan";
    default:
      return resourceType;
  }
}

/**
 * Maps message metadata tags to friendly heading text
 */
export function mapTagsToHeading(tags: string[] | undefined): string {
  if (!tags || tags.length === 0) return "New Message";

  // Check for known tags and return friendly heading
  if (tags.includes("curai-outreach")) {
    return "Curai Outreach";
  }

  // Fallback for any unhandled tags - don't trust backend tags as they're internal
  return "New Message";
}

export function normalizeMessageType(
  type: string | number,
): "text" | "resource" | "attachment" | "unknown" {
  if (type === UniversalMessageType.TEXT || type === "text") {
    return "text";
  }
  if (type === UniversalMessageType.RESOURCE || type === "resource") {
    return "resource";
  }
  if (type === UniversalMessageType.ATTACHMENT || type === "attachment") {
    return "attachment";
  }
  return "unknown";
}
